import React from "react";
import cn from "classnames";

import { Notification } from "src/store/slices/errorSlice/types";

import { useNotificationStack } from "./hooks";

import styles from "./style.module.scss";

import InfoIcon from "src/assets/icons/info.svg";
import WalletIcon from "src/assets/icons/wallet.svg";

type NotificationItemProps = {
  isVisible: boolean;
  notification: Notification;
  onDismiss: () => void;
  onRemoved: () => void;
};

const NotificationItem = ({
  isVisible,
  notification,
  onDismiss,
  onRemoved,
}: NotificationItemProps) => {
  const [exiting, setExiting] = React.useState(false);

  React.useEffect(() => {
    if (!isVisible) {
      setExiting(true);
    }
  }, [isVisible]);

  const handleAnimationEnd = () => {
    if (exiting) {
      onRemoved();
    }
  };

  if (!isVisible && !exiting) {
    return null;
  }

  const iconSrc = notification.variant === "balance" ? WalletIcon : InfoIcon;

  return (
    <div
      className={cn(styles.item, { [styles.exit]: exiting })}
      onAnimationEnd={handleAnimationEnd}
      onClick={onDismiss}
    >
      <div className={cn(styles.icon, styles[notification.variant])}>
        <img src={iconSrc} draggable="false" alt="" />
      </div>
      <div className={styles.text}>
        <span className={styles.title}>{notification.title}</span>
        {notification.subtitle ? (
          <span className={styles.subtitle}>{notification.subtitle}</span>
        ) : null}
      </div>
    </div>
  );
};

export const NotificationStack = () => {
  const { dismissingIds, dismiss, isShow, notifications, remove } =
    useNotificationStack();

  if (!isShow) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.stack}>
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            isVisible={!dismissingIds.has(notification.id)}
            notification={notification}
            onDismiss={() => dismiss(notification.id)}
            onRemoved={() => remove(notification.id)}
          />
        ))}
      </div>
    </div>
  );
};
